<div class="pref-select">
  <div class="all-row">
    <label class="all-label">
      <input
        type="checkbox"
        [checked]="isAllJapanSelected"
        [indeterminate]="isAllJapanIndeterminate"
        [disabled]="disabled"
        (change)="onAllJapanChange($event)"
      />
      全国
    </label>
  </div>

  <table class="area-table">
    <tbody>
      <tr *ngFor="let area of areaGroups">
        <td class="area-cell">
          <label class="area-label">
            <input
              type="checkbox"
              [checked]="isAreaSelected(area)"
              [indeterminate]="isAreaIndeterminate(area)"
              [disabled]="disabled"
              (change)="onAreaChange(area, $event)"
            />
            {{ area.name }}
          </label>
        </td>
        <td class="prefs-cell">
          <div class="prefs">
            <label *ngFor="let pref of area.prefectures" class="pref-label">
              <input
                type="checkbox"
                [checked]="isPrefectureSelected(pref)"
                [disabled]="disabled"
                (change)="onPrefectureChange(pref, $event)"
              />
              {{ pref }}
            </label>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
